import { Component, ComponentType } from 'react';
import { useNavigate, useLocation, useParams, NavLink } from 'react-router-dom';
import { Button, Card, Nav, ButtonGroup } from 'react-bootstrap';

import BCard from '../../../framework/component/container/BCard';

import 'bootstrap/dist/css/bootstrap.min.css';

import './QuizStart.css'

interface QuizResultProps {
    location?: {
        state?: {
            passingScore?: string;
            score?: string;
            pass?: boolean;
            quizId?: number;
            quizName?: string;
        };
    };
}

const PAGE_TITLE = "AMS - Test";

class QuizResult extends Component<QuizResultProps> {

    constructor(props: QuizResultProps) {
        super(props);
    }

    componentDidMount() {
        document.title = PAGE_TITLE;
    }

    render() {
        const state = this.props?.location?.state;

        return (
            <BCard title={state?.quizName ?? ''}
                contentPanel={<>
                    Score: {state?.score}%
                    <br />
                    <br />
                    {!state?.pass ? (
                        <>
                            You have not scored {state?.passingScore}% and therefore have not passed the test.
                            <br />
                            Please refer to the training videos and try again.
                        </>
                    ) : (
                        <>
                            Congratulations, you have passed the test! You can now close this page and your AMS profile will be updated.
                        </>
                    )}
                </>}
                bottomPanel={<>
                    <ButtonGroup>
                        {!state?.pass && state?.quizId &&
                            <NavLink to={`/quiz/${state?.quizId}`} className="nav-link" style={{ marginRight: '10px' }}>
                                <Button variant="primary">Retry test</Button>
                            </NavLink>
                        }
                        <Nav.Link eventKey="home" href="/ams/resProfile">
                            <Button variant="primary">Return to Profile</Button>
                        </Nav.Link>
                    </ButtonGroup>
                </>}
            />
        )
    };
}

const withNavigation = <P extends object>(WrappedComponent: ComponentType<P>) => {
    return (props: P) => {
        const navigate = useNavigate();
        const location = useLocation();
        const params = useParams();
        return <WrappedComponent {...props} navigate={navigate} location={location} params={params} />;
    };
};

export default withNavigation(QuizResult);
